// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Payment from '../components/Payment';
import {actions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    paymentMethods: state.paymentMethodConfig.paymentMethods,
    error: state.paymentMethodConfig.error,
    deleteSuccess: state.paymentMethodConfig.deleteSuccess,
    addSuccess: state.paymentMethodConfig.addSuccess,
    updateSuccess: state.paymentMethodConfig.updateSuccess,
    currency: state.currency.currency,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(Payment);
